export const IntegrationProvider = {
  Jira: 'jira',
  Zapier: 'zapier',
  SalesForce: 'salesforce',
  Slack: 'slack',
  Workato: 'workato',
  Hubspot: 'hubspot',
};

export const IntegrationConsumer = {
  Rocketlane: 'rocketlane',
};
